import React, { useContext, useRef } from "react";
import TableHeaders from "../constants/TableHeaders";
import FortaClass from "../constants/FortaClass";
import Theader from "./Theader";
import medContext from "../context/medContext";
import STOPP from "./STOPP";
import FORTA from "./FORTA";
import BEER from "./BEER";
import ReactToPrint from "react-to-print";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function DrugTable() {
  function Header(event) {
    return <Theader key={event.id} header={event.header} />;
  }
  const getPageMargins = () => {
    return `@page { margin: ${"20px"} ${0} ${"20px"} ${0} !important; }`;
  };
  const context = useContext(medContext);
  const { med } = context;
  const ref = useRef();
  return (
    <div className="flex-center">
      <div ref={ref} className="flex-center drugs-table">
        <style>{getPageMargins()}</style>
        <table>
          <thead>
            <tr>{TableHeaders.map(Header)}</tr>
          </thead>
          <tbody>
            {med.map((medicine, i) => {
              return (
                <tr key={i} className="top-align">
                  <td className="table-border center h-secondary">{i + 1}.</td>
                  <td className="table-border center h-secondary" style={{width: "10vw"}}>{medicine}</td>
                  <td className="table-border" style={{width: "30vw"}}>
                    <BEER drug={medicine} />
                  </td>
                  <td className="table-border">
                    <STOPP drug={medicine} />
                  </td>
                  <td className="table-border" style={{width: "14vw"}}>
                    <FORTA drug={medicine} />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <table style={{ width: "60%"}}>
          <thead>
            <tr className="table-border">
              <th>FORTA Classes and Description</th>
            </tr>
          </thead>
          <tbody>
            {FortaClass.map((event, i) => {
              return (
                <tr className="table-border" key={i}>
                  <div key={event.class}>
                    <td
                      className="forta-cell"
                      style={{ width: "60px", borderRight: "1px solid black" }}
                    >
                      Class {event.class}
                    </td>
                    <td className="forta-cell">{event.description}</td>
                  </div>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <ReactToPrint
        trigger={() => (
          <button className="btn btn-small" id="print">
            PRINT
          </button>
        )}
        content={()=>ref.current}
        pageStyle="print"
        onAfterPrint={()=>toast.success("Print dialog closed successfully!")}
      />
      <ToastContainer 
        position="top-center"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
}

export default DrugTable;
